<template>
  <svg
    v-if="name == 'footerInsta'"
    :class="'ic_' + name"
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="customStyle"
  >
    <path
      d="M19.9453 7.13849C19.8984 6.0141 19.7266 5.2411 19.4804 4.57128C19.2264 3.86029 18.8357 3.22373 18.3239 2.69456C17.8237 2.15716 17.2182 1.73957 16.554 1.47507C15.9172 1.2146 15.1905 1.03277 14.1278 0.983199C13.0572 0.929426 12.7173 0.916992 10.0019 0.916992C7.28657 0.916992 6.94669 0.929426 5.88005 0.979C4.81737 1.02857 4.08679 1.21056 3.45389 1.47087C2.78176 1.73957 2.18014 2.15296 1.68001 2.69456C1.1721 3.22373 0.777586 3.86448 0.527446 4.56724C0.281274 5.2411 0.109427 6.0099 0.0625731 7.13429C0.0117515 8.26707 0 8.62668 0 11.4997C0 14.3728 0.0117515 14.7324 0.0586051 15.861C0.105459 16.9854 0.277459 17.7584 0.52363 18.4282C0.777586 19.1392 1.1721 19.7757 1.68001 20.3049C2.18014 20.8423 2.78573 21.2599 3.44992 21.5244C4.08679 21.7849 4.8134 21.9667 5.87623 22.0163C6.94272 22.066 7.28275 22.0783 9.99812 22.0783C12.7135 22.0783 13.0534 22.066 14.12 22.0163C15.1827 21.9667 15.9133 21.7849 16.5462 21.5244C17.8903 20.9746 18.953 19.8502 19.4726 18.4282C19.7186 17.7543 19.8906 16.9854 19.9375 15.861C19.9843 14.7324 19.9961 14.3728 19.9961 11.4997C19.9961 8.62668 19.9921 8.26707 19.9453 7.13849ZM18.1442 15.7783C18.1012 16.8118 17.9371 17.3698 17.8004 17.7419C17.4643 18.6638 16.7728 19.3955 15.9015 19.751C15.5499 19.8957 15.0186 20.0693 14.0457 20.1147C12.9908 20.1644 12.6744 20.1767 10.0059 20.1767C7.33739 20.1767 7.01705 20.1644 5.96597 20.1147C4.98922 20.0693 4.46177 19.8957 4.11014 19.751C3.67655 19.5815 3.28189 19.3128 2.96154 18.9614C2.62945 18.6182 2.37549 18.2049 2.21524 17.7461C2.0785 17.374 1.91443 16.8118 1.87155 15.7825C1.82454 14.6664 1.81294 14.3314 1.81294 11.508C1.81294 8.68449 1.82454 8.34555 1.87155 7.2336C1.91443 6.20013 2.0785 5.64205 2.21524 5.27C2.37549 4.81108 2.62945 4.39365 2.96551 4.05455C3.28967 3.70317 3.68037 3.43446 4.11411 3.26507C4.46574 3.12038 4.99715 2.94679 5.96994 2.90126C7.02483 2.85168 7.34136 2.83925 10.0097 2.83925C12.6822 2.83925 12.9986 2.85168 14.0497 2.90126C15.0264 2.94679 15.5539 3.12038 15.9055 3.26507C16.3391 3.43446 16.7337 3.70317 17.0541 4.05455C17.3862 4.39769 17.6401 4.81108 17.8004 5.27C17.9371 5.64205 18.1012 6.20416 18.1442 7.2336C18.1911 8.34975 18.2028 8.68449 18.2028 11.508C18.2028 14.3314 18.1911 14.6622 18.1442 15.7783Z"
      :fill="color"
    />
    <path
      d="M10.002 6.06348C7.1656 6.06348 4.86426 8.49827 4.86426 11.4995C4.86426 14.5008 7.1656 16.9356 10.002 16.9356C12.8386 16.9356 15.1398 14.5008 15.1398 11.4995C15.1398 8.49827 12.8386 6.06348 10.002 6.06348ZM10.002 15.0258C8.16189 15.0258 6.66928 13.4467 6.66928 11.4995C6.66928 9.55241 8.16189 7.9733 10.002 7.9733C11.8423 7.9733 13.3347 9.55241 13.3347 11.4995C13.3347 13.4467 11.8423 15.0258 10.002 15.0258Z"
      :fill="color"
    />
    <path
      d="M16.5425 5.84866C16.5425 6.54948 16.0054 7.11773 15.3429 7.11773C14.6806 7.11773 14.1436 6.54948 14.1436 5.84866C14.1436 5.14768 14.6806 4.57959 15.3429 4.57959C16.0054 4.57959 16.5425 5.14768 16.5425 5.84866Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="js">
export default {
  props: {
    name: {
      type: String,
      default:null,
    },
    color: {
      type: String,
      default: "#4D5562",
    },
     strokeWidth:{
        type: String,
      default: "1",
    },secondColor: {
      type: String,
      default: "#E5E7EB",
    },
    sizeType:{
        type: String,
        default: '24',
    },
    customStyle:{default:{}}
  },
  watch: {
  },
  data() {
    return {
      _root: this,
    };
  },
  methods: {},
  destroyed() {},
};
</script>
<style scoped>
@media only screen and (min-width: 280px) {
}
</style>
